import { FC } from 'react';

import SqlQueryRow from '../SqlQueryRow';

import { GraphQLQuery } from '../../types';
import styles from './GraphQLQuerySql.module.css';

type Props = {
  query: GraphQLQuery;
};

const GraphQLQuerySql: FC<Props> = ({ query }) => {
  const sqlQueries = query.response.extensions?.sql ?? [];

  const maxTime = sqlQueries.reduce(
    (max, sql) => (max > sql.time ? max : sql.time),
    0
  );

  return (
    <div>
      <div className={styles.total}>
        Total queries: <strong>{sqlQueries.length}</strong>
      </div>

      {sqlQueries.map((sql, i) => (
        <SqlQueryRow sql={sql} key={i} maxTime={maxTime} />
      ))}
    </div>
  );
};

export default GraphQLQuerySql;
